/*global define*/

define([
    'jquery',
    'underscore',
    'backbone',
    'postal',
    '../Configuration'
], function ($, _, Backbone, postal, Configuration) {
    'use strict';
    var draggable = require('jquery-ui/ui/widgets/draggable');
    var droppable = require('jquery-ui/ui/widgets/droppable');

    var ToolView = Backbone.View.extend({
        contextMenuOpen: false,
        tagName: 'div',
        events: {
            'click #zeroButton': 'zero',
            'click #flameUp': 'incrementFlameHeight',
            'click #flameDown': 'decrementFlameHeight'
        },
        render: function(){
            var power;
            if (this.model.get("bunsenBurner")) {
                power = this.model.get("bunsenBurner").power;
            }
            this.unbind();
            this.$el.html(this.template({
                cid: this.model.cid,
                flameHeight: this.model.get("flameHeight"),
                weight: this.model.get("weight"),
                upEnabled: this.upEnabled,
                downEnabled: this.downEnabled,
                power: power
            }));
            var winWidth = $("#vlab").width();
            var scaleFactor = 1;
            if (winWidth < 768) {
                scaleFactor = .5;
            } else if (winWidth >= 768 && winWidth <= 991) {
                scaleFactor = .75;
            } else if (winWidth >= 992 && winWidth <= 1199) {
                scaleFactor = 7 / 8;
            }
            scaleFactor *= Configuration.userScaleFactor;
            var svg = this.$el.find("svg");
            var width = svg.attr("width");
            svg.attr("width", width * scaleFactor);
            var height = svg.attr("height");
            svg.attr("height", height * scaleFactor);
            this.setDragAndDrop();
            var cid = this.model.cid;
            this.$el.bind("contextmenu", function(event) {
                event.preventDefault();
                event.stopImmediatePropagation();
                $(".removeTool").attr("id", cid);
                var menu = $(".toolContextMenu");
                menu.css({display: "block", top: event.pageY - menu.height(), left: event.pageX - menu.width()});
            });
            $(document).unbind("click");
            $(document).bind("click", function(event) {
                $(".contextMenu").hide();
                this.contextMenuOpen = false;
            });
        },
        initialize: function(){
            //this.el = $('<div class='+this.model.attributes.vessel.vesselClass+'>');
            this.upEnabled = true;
            this.downEnabled = true;
            //this.template = require("ejs!" + this.model.attributes.tool.template);
            //this.template = JST[this.model.attributes.tool.template];
            var name = this.model.attributes.tool.template;
            //console.log('name  is ' + name)
            if (name.includes('bunsenBurner')) {
              this.template = require('ejs-loader!../templates/bunsenBurner.ejs');
            }
            else if (name.includes('scale')) {
              this.template = require('ejs-loader!../templates/scale.ejs');
            }
            this.$el.attr('id', this.model.cid);
            this.$el.addClass("tool")
            _.bindAll(this, "render");
            this.model.bind('change', this.render);
            $(window).resize(function(){
                this.render();
            }.bind(this));
        },
        setDragAndDrop: function(){
            this.$el.draggable({
                opacity: 0.6,
                scroll: false,
                scope: "workbench",
                containment: "parent",
                distance: 10
            });
            this.$el.droppable({
                accept: "div",
                scope: "workbench",
                hoverClass: "drag-hover"
            });
            this.$el.css("position", "absolute");
        },
        zero: function(){
            var channel = postal.channel("logger");
            channel.publish("update", {observable: this.model, arg: this.model.get("weight")});
            this.model.set("weight", 0);
        },
        incrementFlameHeight: function(){
            var bunsenBurner =  this.model.get("bunsenBurner");
            if (Math.floor(bunsenBurner.power * 10) / 10 < 1.6) {
                bunsenBurner.power += .1;
                this.model.set("bunsenBurner", bunsenBurner);
                var channel = postal.channel("logger");
                channel.publish("update", {observable: this.model});
            }
            if (Math.floor(bunsenBurner.power * 10) / 10 >= 1.6) {
                this.upEnabled = false;
            }
            if (!this.downEnabled) {
                this.downEnabled = true;
            }
            this.render();
        },
        decrementFlameHeight:function(){
            var bunsenBurner =  this.model.get("bunsenBurner");
            if (Math.floor(bunsenBurner.power * 10) / 10 > 0) {
                bunsenBurner.power -= .1;
                this.model.set("bunsenBurner", bunsenBurner);
                var channel = postal.channel("logger");
                channel.publish("update", {observable: this.model});
            }
            if (Math.floor(bunsenBurner.power * 10) / 10 <= 0) {
                this.downEnabled = false;
            }
            if (!this.upEnabled) {
                this.upEnabled = true;
            }
            this.render();
        }
    });

    return ToolView;
});
